import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import IconAction from '../../../dashboard/components/shared/IconAction';
import { getInitials } from '../../../dashboard/components/shared/PatientItem';
import { chatReading, formatFullDate, plural, whatsappWebUrl } from '../utils';
import styles from '../Recovery.module.css';

const READING_CHAT_TEXT = 'Lendo a conversa...';

/**
 * Calibração: uma pessoa que cabia no horário e ficou fora da rodada. Mostra
 * o motivo da recusa, a nota, as razões que contaram, a leitura completa da
 * conversa e os atalhos (cadastro e WhatsApp Web). Sem Chamar: aqui só se
 * confere o resultado.
 */
function RejectedRow({ candidate }) {
  const reasons = candidate.reasons || [];
  const reading = chatReading(candidate.chat);
  const chatUrl = whatsappWebUrl(candidate.phoneDigits);

  const meta = [
    candidate.lastVisit ? `Último atendimento ${formatFullDate(candidate.lastVisit)}` : 'Sem atendimento realizado',
    candidate.visits ? plural(candidate.visits, 'atendimento', 'atendimentos') : null,
    candidate.phone || null,
    `nota ${candidate.score}`,
  ].filter(Boolean).join(' · ');

  const openRecord = () => window.open(`/patients/${candidate.patientId}`, '_blank', 'noopener');
  const openChat = () => window.open(chatUrl, '_blank', 'noopener');

  return (
    <div className={styles.candidate}>
      <span className={styles.avatar} aria-hidden="true">{getInitials(candidate.name)}</span>

      <div className={styles.candidateInfo}>
        <button type="button" className={styles.candidateName} onClick={openRecord} title="Abrir cadastro">
          {candidate.name}
        </button>
        <span className={styles.candidateMeta}>{meta}</span>
        <span className={styles.rejection}>{candidate.rejection}</span>

        {(reasons.length > 0 || candidate.chat?.pending) && (
          <div className={styles.reasons}>
            {reasons.map((reason) => (
              <span key={reason.code} className={`${styles.reason} ${styles.reasonNeutral}`}>{reason.text}</span>
            ))}
            {candidate.chat?.pending && (
              <span className={`${styles.reason} ${styles.reasonNeutral}`}>{READING_CHAT_TEXT}</span>
            )}
          </div>
        )}

        {reading && <span className={styles.chatReadingFull}>{reading}</span>}
      </div>

      <div className={styles.candidateActions}>
        <div className={styles.iconRow}>
          {chatUrl && (
            <IconAction title="Abrir a conversa no WhatsApp Web" onClick={openChat}>
              <WhatsAppIcon style={{ fontSize: 16 }} />
            </IconAction>
          )}
          <IconAction title="Abrir cadastro em nova aba" onClick={openRecord}>
            <OpenInNewOutlinedIcon style={{ fontSize: 16 }} />
          </IconAction>
        </div>
      </div>
    </div>
  );
}

export default RejectedRow;
